import errorHandler from '../request/errorHandler';

export type WriteResult<T> =
  | { ok: true; data: T }
  | { ok: false; status: number; message: string };

const detailOf = (data: any): string | null => {
  if (typeof data?.detail === 'string') return data.detail.trim() || null;
  if (Array.isArray(data?.detail)) {
    const joined = data.detail
      .map((entry: any) => entry?.msg)
      .filter((t: unknown): t is string => typeof t === 'string' && t.trim() !== '')
      .join('\n');
    return joined || null;
  }
  return null;
};

/** Runs a write; 400/404/409 come back as a message for the form, the rest go to errorHandler. */
export const runWrite = async <T>(call: () => Promise<{ data: T }>): Promise<WriteResult<T>> => {
  try {
    const response = await call();
    return { ok: true, data: response.data };
  } catch (error: any) {
    const status = error?.response?.status;
    if (status === 400 || status === 404 || status === 409) {
      const message = detailOf(error.response.data);
      if (message) return { ok: false, status, message };
    }
    errorHandler(error);
    return { ok: false, status: status ?? 0, message: 'The request failed.' };
  }
};
